import { LangData } from "../types";

const lang: LangData = {
  // App.vue
  selectLang: "Select Language",
  cancel: "Cancel",
  clientArea: "Customer area",
  seeAllStores: "All Companies",
  addStore: "Add Company",
  login: "Log in",
  signUp: "Sign Up",
  contact: "Contact",
  editData: "Edit data",
  logout: "Log out",
  store: "Store",

  //Auth Login Form
  authTitle1: "ACCESS TO CUSTOMER AREA",
  rememberPassword: "Remember password",
  requiredEmailAlert: "Please enter an email.",
  validEmailAlert: "The email must be valid.",
  passwordLegend: "Forgot password?",
  toAccess: "Log in",
  activeSessionLegend:
    "There is an active session in this browser. Please confirm the account with which you want to access the system.",
  accessThisAccount: "Access with this account",
  useOtherUser: "Use another user",
  recoverPasswordLegend:
    "Enter your email and we will send you a message with instructions that will allow you to recover your password.",
  email: "Email",
  sendMessage: "Send Message",
  sendMessageLegend1: "¡Message sent!",
  sendMessageLegend2: "Follow the instructions in the message to reset your password.",
  sendMessageLegend3: "If you don't receive the message in a few minutes, check your SPAM box.",
  errorMsgLogin: "Log in failed",
  errorMsgForm: "Please complete the form data.",
  errorMsgEmail: "The mail could not be sent",
  mfaCodeSentLegend:
    "We've sent you an SMS with a code to your phone. Enter it below to confirm your number and complete the linking of your account.",
  verificationCode: "Verification code",
  twoFactorAuth: "Two-factor authentication",
  mfaExplanationTitle: "Protect your account with two-step verification",
  mfaExplanationBody:
    "By adding your phone number, we'll send you a code via SMS every time you sign in from a new device. It's an extra layer of security to make sure no one else can access your data, even if they know your password.",
  mfaEnrolledLegend: "You have the following phone configured for two-step verification:",
  mfaRemove: "Remove",
  mfaSendCode: "Send code",
  mfaCredentialTooOld: "For security reasons, please log out and log back in before retrying this action.",
  mfaUnverifiedEmail: "You must verify your email before you can set up two-step verification. Complete the verification code sent to your email (without skipping it) to continue.",
  password: "Password",
  preserveLogin: "Stay Signed In",
  optionalName: "Username (optional)",
  welcome: "Welcome",

  // AUTH LOGIN
  adminAccessTitle: "Administration access",
  loggingAlert1: "Please wait a moment while access is validated.",
  loggingAlert2: "The session will last only until you close the browser.",
  loggingError: "An error occurred while verifying the login:",
  retry: "Retry",
  noCommerceId1: "Trading with ID ",
  noCommerceId2: "does not currently exist on PAYTEF Web.",
  noCommerceId3: "To see the options of this business press continue to add it to the system.",
  continue: "Continue",
  redirectSuccess: "Successful login. Redirecting...",
  noRegister: "Don't have an account?",
  singUpHere: "Sign up here.",
  errorMsgRedirect: "Error trying to continue",

  // AUTH REGISTER
  registerLegend: "To carry out this step you must have the company data provided by PAYTEF at hand.", //VER
  addCommerce: "Add Company",
  registerAsAdmin: "Sign in as Administrator",
  emailValidationErr: "There was a problem validating the account. Try again.",
  emailVAlidationErr2: "Error validating the account, check the data",
  dataErr: "Check that the data is correct",
  registerErr: "The user could not be registered, check the data.",
  validatingEmail: "Validating email...",
  userExist: "Existing user, you can continue to the next step.",
  newUserDataText: "New user. Please indicate the data below.",
  waitingVilidation: "Waiting for verification.",
  emailDisponibility: "Enter an email to validate it's availability.",
  userName: "Username",
  paytefClientId: "PAYTEF Customer ID",
  paytefUserName: "PAYTEF Username",
  paytefPassword: "PAYTEF Password",
  paytefNoDataLegend: "Don't have these data? Contact us to request them.",
  registerCommerce: "Register Company",
  successCommerceLink1: "The Company ",
  successCommerceLink2: " was associated with your user account.",
  commerceData: "Company Data:",
  name: "Name",
  city: "City",
  address1: "Address 1",
  address2: "Address 2",
  accessSistemLegend: "Log in to view.",
  registerSuccessRedirect: "Registration completed, proceed to the access page to enter the system.",
  exit: "Log out",
  accessSistem: "Access the system",
  ruleClientId: "Please enter a customer ID.",
  ruleNumericClientId: "The client ID must be numeric.",
  ruleRequireduserName: "Please enter a username.",
  ruleRequiredPassword: "Please enter the password.",

  // PASSWORD
  ruleConfirmPasword: "Please confirm your password.",
  ruleMinChar1: "The password must have ",
  ruleMinChar2: " characters or more.",
  rulePasswordReq: "Enter the password.",
  ruleConfirmation: "Confirmation must be equal to ",
  repeatThe: "Repeat the ",

  // SIDEBAR
  storeMenu: "Company",
  transactions: "Transactions",
  connectionStatus: "Connection status",
  myStores: "Companies",
  userManagement: "User Management",
  officeconfig: "Branch Configuration",
  vending: "Vending",
  tools: "Tools",
  paymentRequest: "Payment requests",
  newRequest: "New request",
  clientAPI: "Client API",
  paymentLinkAPI: "Payment Link API",
  development: "Development",
  lastChanges: "Latest changes",
  storeMenuHint: "Check the status of your terminals.",
  transactionsHint: "Check transactions made in your company from PAYTEF terminals.",
  connectionStatusHint: "Check the connection status of any of your terminals.",
  myStoresHint: "See the list of companies assigned to my user.",
  userManagementHint: "Manage all those users to whom you want to give permission to consult Companies.",
  officeconfigHint: "Manage the configuration of branches enabled for Payment Link.",
  vendingHint: "Configuration of vending machines.",
  topayHint: "Global list of the oldest pending Topay messages across all terminals.",
  topayNoMessages: "No Topay messages found.",
  paymentRequestHint: "View the status and manage payment requests sent by Payment LINK.",
  newRequestHint: "Create new payment request and send it.",
  clientAPIHint: "See PAYTEF API documentation for clients.",
  paymentLinkAPIHint: "Enable access to the PaymentLink API and view the documentation.",
  paymentLink: "Payment LINK",
  euroshellCertificate: "Euroshell Certificate",
  euroshellCertificateHint: "Create euroshell certificate and check history",

  //CompanyInfo
  showInactive: "Show Inactive",
  hideInactive: "Hide Inactive",
  editLogoBtn: "Edit Logos",
  loadingTheStore: "Loading company...",
  loadingError: "There was an error loading the company. ",
  message: "Message",
  searchOffice: "Search branch...",
  searchOfficeTcodSn: "Search branch, TCOD or SN...",
  exportToExcel: "Export branches to Excel",
  selectBranchTerminalInfo: "Select a branch or terminal to see its data",
  officeID: "Branch ID",
  code: "Code",
  tcod: "TCOD",
  activation: "Activation",
  lastConnection: "Last connection",
  release: "Release",
  devices: "Devices",
  latencyMin: "Latency (minutes)",
  pcAndIp: "Machine and local IP",
  lastIP: "Last IP",
  connectionDetails: "Connection details",
  queryTransactions: "Query transactions",
  unlockPassword: "Unlock password",
  ConfigQR: "Setup QR Code",
  errorCreateQR: "Error creating QR",
  backToMyMerch: "Back to Companies",
  backToList: "Back to list",
  errorData: "An error occurred while querying the data",
  copyUrl: "Copy Url",
  urlCopied: "Copied Url",
  devHardware: "Hardware",
  devDeviceModel: "Model",
  devStatus: "Status",
  devManufacturerCode: "Manufacturer",
  devSerialNumber: "S/N",
  devSoftwareVersion: "Software Ver.",
  detail: "Details",
  clientID: "Client ID",
  province: "Province",
  postCode: "Postal Code",
  address: "Address",
  commerceCodes: "Commerce Codes",

  //TRANSACTIONQUERYV3
  queryOfTransactions: "Query Transaction",
  filters: "Filters",
  changeFilters: "Change Filters",
  exportListToExcel: "Export list to excel",
  showStadistics: "Search Statistics",
  office: "Branch",
  loading: "Loading...",
  selectMerchant: "Select a company",
  terminal: "Terminal",
  noTerminals: "No terminals",
  dates: "Dates",
  note: "Note",
  pdfReportsLegend: "PDF reports are only available for ranges less than 45 days.",
  amount: "Amount",
  lowerLimit: "Lower limit",
  higherLimit: "Upper limit",
  reference: "Reference",
  operationReference: "Operation Reference",
  transactionID: "Transaction ID",
  operationNumber: "Operation number",
  cardBinLabel: "Card BIN",
  cardBinPlaceholder: "First digits of the card",
  cardTypeLabel: "Card type",
  authCodeLabel: "Authorization code",
  authCodePlaceholder: "Authorization code",
  pdfListFormat: "List in PDF format",
  transactionSummary: "Transaction Summary",
  statistics: "Statistics",
  partialResult: "Partially loaded result",
  transactionsPorcDownload1: "Downloaded ",
  transactionsPorcDownload2: "of the transactions available for the selected date range.",
  continueDownload: "Continue download",
  loadingText: "Loading transactions... Please wait a moment.",
  transactionsAlertTitle:
    "Some transactions could not be added to the total because they had formatting errors in the amount",
  totalAmount: "Total",
  loadingTransactions: "Loading transactions",
  loadingTransactionsWait1: "Downloading transactions from",
  loadingTransactionsWait2: "days",
  loadingTransactionsWait3: "Wait a moment please...",
  loadingTransactionsWait4: "companies",
  loadingTransaccionsAlert: "This operation may take a few minutes.",
  failed: "Failed",
  aprove: "Approved",
  denied: "Denied",
  errorIndeterminate: "An undetermined problem occurred and the transaction failed. You can try to do it again.",
  successfulOperation: "The operation was completed successfully.",
  deniedOperation: "The operation was denied by the processing center.",
  result: "Result",
  transaction: "Transaction",
  card: "Card",
  seeReceipt: "See Receipt",
  finish: "To finalize",
  ruleValueRequired: "Required value",
  ruleNumericValue: "Numerical value",
  selectOfficeToFilter: "Select the branch to filter by operation number",
  errorSelectParams: "Select the parameters before making the query.",
  errorLoadPage: "Failed to load the pages",
  errorUnexpected: "Unexpected error loading transactions, try again",
  errorMissingFilters: "Filters are missing",
  errorTryAgain: "Error getting results, please try again.",
  selectFiltersToDownload: "Select the filters to download the file",
  errorCheckFilters: "Check the filters",
  successFileGenerated: "File generated",
  errorDownloadingFile: "Error downloading the file",
  errorGeneratingFile: "Failed to generate file",
  errorQueryTransactions: "Error consulting transactions",
  noResults: "There are no results to download, check the filters",
  allOffices: "All branches",
  company: "Company",
  companies: "Company",
  date: "Date",
  errorPdfFormatNotAvailable: "Download format not available for multiple companies.",
  withoutCard: "Without card",
  totalProgess: "Overall Progress",
  maxDaysLimit: "The maximum search period must be 31 days.",
  byBankAndCard: "By Bank and Card - Amount",
  byBankAndCard2: "Por Banco y Tarjeta - Quantity",
  bank: "Bank",
  filteredTransactionsShowDetails: "To see a greater detail of the filtered transactions click here",
  newTransaction: "New transaction",
  manualClose: "Manual Close",
  manualCloseType: "Operation Type",

  filterBy: "Filtrar Por",

  // txnNewDialog
  opType: "Operation type",
  cardNumber: "Card number",
  expirationDate: "Expiration date",
  securityCode: "Security code",
  cfTitleCardData: "Credit/Debit Card",
  cfTitleExtraData: "Billing information",
  ciCardNameTitle: "Cardholder's name",
  ciCardNumberTitle: "Card number",
  ciExpireLabel1: "valid",
  ciExpireLabel2: "until",
  ciExpireTitle: "month/year",
  ciSecurityCodeTitle: "Security code",
  fCardNameLabel: "Cardholder's name",
  fCardNamePlaceholder: "-",
  fCvvLabel: "Security code",
  fCvvPlaceholder: "XXX",
  fExpireLabel: "MM / YY",
  fExpirePlaceholder: "__/__",
  fPANLabel: "Card number",
  fPANPlaceholder: "······ ··········· ··",
  errCardInvalid: "Card number invalid",
  errCardNameRequired: "Mandatory field",
  errCardRequired: "Enter the card number",
  errExpirationInvalid: "Expiration must be MM / YY",
  errExpirationRequired: "Expiration date is necessary",
  errSecurityCodeInvalid: "Invalid code",
  errSecurityCodeRequired: "Security code is needed",
  authorization: "Authorization",
  test: "Test",
  operationDetails: "Operation Detail",
  cardDetails: "Card Data",
  authAmount: "Amount to Preauthorize",
  testAmount: "Amount to Test",
  alertExecuteTransaction: "¡Transaction executed successfully!",
  errorCouldNotExecuteTransaction: "The transaction could not be executed",

  //transactions_query.ts
  dateTime: "Date hour",
  operation: "Operation",
  sale: "Sale",
  refund: "Refund",
  preauthorization: "Preauthorization",
  preauthorizationClose: "Preauthorization Close",
  preauthorizationCancelation: "Preauthorization Cancel",
  amountTest: "Balance test",
  cancellation: "cancellation",
  tokenization: "Tokenization",
  requestedAmount: "Amount requested",
  finalAmount: "Final Amount",
  authorizationCode: "Authorization Code",
  transactionCost: "Transaction Cost",
  state: "State",
  dcc: "DCC",
  country: "Country",
  resultCode: "Result Code",
  sessionDate: "Session Date",
  commerceCode: "Company Code",
  device: "Device",
  entryMode: "Entry Mode",
  titular: "Titular",
  pan: "PAN",
  cardBin: "Card BIN",
  cardIssuer: "Issuer and Country",
  companyCard: "Company card",
  creditoOrDebit: "Credit or Debit",
  server: "Server",
  processStatus: "Status Process",
  authorizationCenter: "Authorizing Center",
  merchantBank: "Merchant Bank",
  t1: "T1",
  t2: "T2",
  id: "ID",
  approvedPlural: "Approved",
  deniedPlural: "Denied",
  failedPlural: "Failed",
  generalInfo: "General Information",
  cardData: "Card Data",
  processing: "Processing",

  // BranchConfig.vue
  officeConfiguration: "Branch Configuration",
  loadingMerchant: "Loading Company...",
  selectMerchantToSeeOffice: "Select a company to see the branches",
  errorLoadingOffice: "An error occurred loading the branches.",
  merchantNoOffice: "This company does not have branches to configure",
  selectOfficeToSeeConfig: "Select an branch to see the configuration",
  backendEnv: "Backend environment",
  backendEnvHint: "Determines which server processes transactions",
  nameToShow: "Display name",
  version3dS: "3D Secure Version",
  version3dSTxt1: "It is recommended to use version 2.0. Version 1.0 is included for compatibility only.",
  version3dSTxt2: "Check with PAYTEF to make sure you have version 2.0 enabled before modifying this property.",
  version3dSlbl2: "3D Secure 2.0",
  customStyle: "Customize page style",
  officeIdentification: "Branch Identification",
  officeIdentificationText: "It will appear in the header of the form and at the bottom of the PUCE panels.",
  imgSizeLegend: "The image must be 50 pixels high and a maximum of 300 pixels wide.",
  customCssFile: "Custom CSS file",
  optionalStyleText: "Optional style sheet to further customize the style of the pages.",
  uploadCss: "Upload Css",
  restpreOriginal: "Restore original",
  paymentLinkLowercase: "Payment Link",
  paymentWebData: "Data for the payment page",
  image: "Image",
  requiredLogoConfig: "It is necessary to configure a logo",
  change: "Change",
  contactEmail: "Contact email",
  contactPhone: "Telephone contact",
  senderName: "Sender name",
  senderNameHint: "This value will appear in the signature of the e-mails to the client",
  resultEmail: "Results email",
  resultEmailHint: "You will receive a notification in this box when a customer has paid",
  errorEnableOffice:
    "The branch could not be enabled because the HMAC signing key is missing. Contact support to set it up.",
  errorIncorrectForm: "Errors were found in the form, please review them and try again.",
  previewInPuce: "Preview in PUCE",
  save: "Save",
  configuredOffices: "Configured branches",
  available: "Available",
  branchName: "Branch name",
  pickImg: "Select image...",
  circle: "Circle",
  square: "Square",
  squareRounded: "Rounded square",
  emailNotification: "Notify expiration to E-mail ",

  // ConnectionStatus.vue
  selectTerminalToSeeConnectionData: "Select the terminal to see the connection data.",
  noDataFound1: "No records found for",
  noDataFound2: "in the date",
  noDataFound3: "Try other filters",
  selectFiltersToSeeTable: "Select the filters to see the table.",
  openFilters: "Open filters",
  hour: "Hour",
  latency: "Latency",
  conectionState: "Connection state",
  connectionStates: "Connection states",
  selectParametersToFilter: "Select parameters before filtering",
  errorFilteringResults: "Error filtering the results",

  // CompanyCatalog.VUE
  welcomeTitle: "Welcome to the PAYTEF Customer Area",
  welcomLegend1: "From here you can manage the different companies associated with your account.",
  welcomLegend2: "Please select the company you wish to trade below.",
  searchMerchant: "Search company...",
  userAdministration: "User Management",
  addMerchant: "Add Company",
  loadingMerchants: "Loading companies...",
  errorLoadingMerchant: "An error occurred loading companies.",
  myMerchants: "my companies",
  add: "Add",
  deleteMerchantAlert: "Are you sure you want to remove this company from your profile?",
  failedToSaveUser: "Failed to save user",
  filteredOffices: "Filtered Branches",
  offices: "Branches",
  searchByBranch: "Search by branch or customer ID or TCOD",
  searchByBranchHint: "Note: TCOD only searches for the branch, not the terminal",
  showMore: "Show more...",
  showMoreMessage: "Showing %1 of %2 companies",

  // HOME.VUE
  welcomeTitleACP: "Welcome to the PAYTEF (ACP) customer area",
  welcomLegendACP1: "From here you can manage all your PAYTEF payment terminals in real time.",
  dontHaveUser: "You don't have a user yet?",
  homeText1:
    "If you are the administrator of your company, you can register the administration user with the assigned credentials.",
  homeText2: "If you do not have them, you can contact us to request them.",
  homeText3:
    "If you are not an administrator, you must request your credentials from the administrator of your company.",
  registerAsAdministrator: "Register as Administrator",
  requireCredentials: "Request my credentials",
  whatIsPaytef: "What is PAYTEF?",
  paytefDescription:
    "PAYTEF is a payment gateway that allows the interconnection of a simple interface with the POS management application.",
  knowMore: "Learn more",
  whatIsAcp: "What is PCA?",
  acpDescription:
    "PAYTEF CUSTOMER AREA (PCA) is an area that allows PAYTEF users to fully manage their payment terminals. For example, you will be able to consult from anywhere and in real time all the banking transactions carried out through any of your terminals in an easy and secure way.",
  howToUseAcp: "How is PCA used?",
  howToUseAcpText:
    "All you have to do is ask us for your access data and with them register in the system as Administrator of your business. Once completed, you will have access to different functionalities such as consulting the transactions of all the terminals of your company, or how to manage your users and the branches to which they will have access.",

  // UserManager.vue
  usersAdministration: "Users Management",
  search: "Search",
  refresh: "Refresh",
  access: "Access",
  import: "Import",
  notAssigned: "Not assigned",
  merchantWithoutUsers: "This company has no users.",
  theSearchNoResults1: "The search of",
  theSearchNoResults2: "did not get results.",
  couldNotAccessUserList: "Could not get list of users",
  selectMErchantDialog: "Select a business",
  removingAccessAlert1: "It is removing access from",
  removingAccessAlert2: "to the company",
  removingAccessAlert3: "do you wish to continue?",
  deletedUserRefresh: "Deleted user, refreshing list.",
  couldNotRemoveUser: "Failed to delete user",
  successfulAction: "Successful action, refreshing list.",
  failedAction: "Could not execute this action",
  merchant: "Company",
  email2: "Email",
  permissions: "Permissions",
  lastAccess: "Last Access",
  terminalsStatus: "Terminals Status de Terminales",
  seeTransactions: "See Transactions",
  basicRole: "Basic Role",
  all2: "All",
  administrator: "Administrator",
  searchOfficeByNameID: "Search for an office by name or ID...",

  // ClientAPI.vue
  paytefClientApi: "PAYTEF API for clients",
  generalOpAuthTitle: "General operations and authentication",
  wayToMakeCall: "All calls to the PAYTEF API will be made as follows:",
  desiredFunction: "{desiredfunction}",
  optionalParamsText:
    "Optionally, the ?env=preprod parameter can be added if indicated by support, to access some functionality that is still in the pre-production environment, but this will only be under indication of support.",
  authFirstData: "The authentication will be the first data block to send, followed by the parameters; for instance:",
  reqDistinctParams: "The different parameters of the request",
  authParams: "This authentication will include:",
  merchantId: "The company ID",
  assignedUserName: "The assigned username",
  assignedPassword: "The assigned password",
  dataProvidedBySuport: "All these data will be provided by PAYTEF support when creating a new company.",
  resErrorHandleTitle: "Response and error handling",
  resFortySecText1:
    "All requests must wait a minimum of 40 seconds to obtain a response (especially in cases such as transaction queries where the volume to be returned can be large).",
  resFortySecText2: "The answers will come as ",
  resSuccessful:
    "In case of a successful response, they will return a '200 – OK' code, and the body of the message in JSON:",
  forExample: "For example",
  errorHandle: "Error handling:",
  resError400: "Errors in the request (eg: incorrect password): Code '400 – Bad Request' and",
  resError500: "System errors: Code '500 – Server Error'; no more info normally",
  docCompability: "The API documentation is not compatible with Internet Explorer 11, please update your browser.",

  //Changelog.vue y changeLog.ts
  siteRecentChanges: "Recent Site Changes",
  generalChanges2: "General changes",
  generalChangesItem1: "Branches now display client IDs if available",
  generalChangesItem2: "The size of the configuration QR is larger so that the device recognizes it better",
  generalChangesItem3:
    "The border of the configuration QRs has been eliminated so that it can be recognized more easily",
  generalChangesItem4:
    'Transactions: Dates correct themselves in the filter when selecting a "from" date after the "to" date or a "to" date before the "from" date',
  generalChangesItem5: "Fine-tuning and updating of all dependencies to correct vulnerabilities and bugs",
  generalChangesItem6: "General improvements to the visual style of the site",
  generalChangesItem7: "New Changelog Page",
  generalChangesItem8: "New style for API documentation and various bug fixes",
  generalChangesItem9:
    "New 'unlock password' visible in 'Companies' section, for admins only. Allows temporary unlocking of kiosk mode on devices.",
  generalChangesItem10: "'Balance test' transactions now allow sales to be made on the tested card.",
  generalChangesItem11: "Correction of a bug that did not allow to modify the logos in 'Branch Configuration'",
  generalChangesItem12: "Copyright year updated",
  generalChangesItem13: "API menus moved to development section",
  vending2: "Vending",
  vendingItem1: "New vending page to configure the terminals",
  vendingItem2: "Improvements to the vending configuration page",
  vendingItem3: "New user role that allows modifying vending without being an administrator",
  vendingItem4:
    "The Vending menu has been moved under 'Branch settings' and always appears if the user has the permission assigned",
  connectionStatus2: "Connection status",
  connectionStatusItem1: "When modifying the company, or the branch, the list is cleaned",
  connectionStatusItem2:
    "BUGFIX: The download of the PDF and the excel now reflect the correct date of the last query made",
  transactions2: "Transactions",
  transactionList2: "Transaction list",
  transactionListItem1: "New filter by amount",
  transactionListItem2: "When modifying the business, the filters and the list are cleaned",
  transactionListItem3: "The branch combobox is now searchable",
  transactionListItem4: "New dynamic filters for each column that filters the rows at the moment",
  transactionListItem5: 'New filter in the query by "Terminal"',
  transactionListItem6: "Mobile version of the list that shows the details vertically",
  transactionListItem7:
    "The home page is now the Transactions list. If the user has 1 trade it will be selected automatically.",
  transactionListItem8: "Small corrections to the terminology of the dialog to edit pre-authorizations",
  transactionListItem9:
    '"Preauthorization Cancellation" transactions now allow the "New Collection" action to be performed',
  transactionListItem10: "New receipt download in 'Image' format",
  transactionListItem11: "Corrections of margins and font sizes for receipts in PDF format",
  officeConfig2: "Branch Configuration",
  officeConfigItem1: "Branches are listed in alphabetical order",
  officeConfigItem2: "New text box to search branch by name",
  paymentLink2: "Payment LINK",
  paymentLinkItem1: "BUGFIX: An error occurred when canceling the upload of attachments",
  paymentLinkItem2:
    "BUGFIX: The logo was cropped if it was too tall and narrow, now it shrinks to the appropriate size",
  paymentLinkItem3: "The maximum size of attachments before uploading is now indicated and controlled in the client",
  paymentLinkItem4: "The ID of the request is shown in the list below the link and the list can be filtered by ID",
  paymentLinkItem5: 'New button "Go to request" that allows to enter the ID and open the editing window directly',
  paymentLinkItem6: "Test requests now have a mark in the list to differentiate them more easily.",
  paymentLinkItem7:
    "It is now possible to select 3D Secure 2.0 for payment requests. The option must be enabled in 'Branch Settings'.",
  paymentLinkItem8: "Some minor styling changes to the checkout page",
  paymentLinkItem9: "Correction of styles to the visualization of emails",
  usersAdmin2: "User Management",
  usersAdminItem1: "New utility to create users in bulk using a spreadsheet",
  users2: "Users",
  usersItem1: "The access restriction by branch now allows you to select more than one.",
  changelogDec1: "User start page is now selected by role",
  changelogDec2: "Several updates to the vending page",
  changelogFeb1: "New interface to pick the main screen logo of the PIN/PAD and it's receipt logo.",
  changelogFeb2: "New updates to API definitions",
  changelogFeb3: "BUGFIX: Error messages were hidden by accident in long pages",
  changelogFeb4: "New button to send emails directly from payment requests",
  changelogFeb5: "User language selection is now persisten between sessions",
  changelogFeb6: "BUGFIX: Undefined email languages now default to english instead of empty",
  changelogFeb7: "New feature to assign a request's expiration in hours instead of a date",
  changelogFeb8: "New languages added to the website and multilanguage support added for emails",
  changelogJun1: "New animated card when writting credit card information",
  changelogJun2: "Several improvements to website theme and better support for mobile",
  changelogJun3: "Improvements on the backend and security fixes",
  changelogJun4: "Support for the new token transaction",
  changelogAug1: "Multilanguage support for this website. Added english language",

  changelogAug2: "Transactions. New functionality to view transactions for all companies.",
  changelogAug3: "BUGFIX: support for retrying query transactions",
  changelogAug4: "Improved images and detail of topay",
  changelogAug5: "Host Selection added.",
  changelogSep1: "Transactions link to the previous transaction",
  changelogSep2: "Transaction queries are limited to 31 days",
  changelogSep3: "Tokenization added",
  changelogSep4: "Incorporation of DCC information",
  changelogNov1: "Transactions. Statistics section",
  changelogNov2: "Incorporation of expiration notification URLs to the client",
  changelogNov3: "Adding 'Visible Credits' to Topay",
  changelogNov4: "Create Administration screen and display token.",
  changelogNov5: "Mark when it is edition",
  changelogNov6: "Browser language recognition",
  changelogNov7: "Incorporation of notification upon expiration",
  changelogDec3: "Incorporation of 'Recharger' operating mode",
  changelogDec4: "Addition of 'Read toPay' parameter",
  changelogEne1: "Adding language to settings",
  changelogEne2: "Improved token validation",
  changelogEne3: "Transactions. Support for bizum returns",
  changelogFeb9: "Incorporation of Euroshell certificates",
  changelogFeb10: "Modifying pulse mode parameters",
  changelogFeb11: "My companies. Incorporation of business search by office code",
  changelogFeb12: "Improved transaction statisticss",
  changelogFeb13: "Dataphone operation support.",
  changelogAbr1: "Incorporation of sale with operation prior to maturity",
  changelogMay1: "Transactions. New time filter by processing or location",
  changelogMay2: "Commerce. Button to copy QR URL added",
  changelogMay3: "Bizum operation support",
  changelogMay4: "PUCE. Remove 3D Secure 1.0",
  changelogMay5: "Transactions. Suport Sale (forced) and Return (forced)",
  changelogMay6: "Improved screen settings and preview",
  changelogJun5: "Transactions Improved Excel export (incorporation of 'Previous Operation' column)",
  changelogJun6: "Device Statistics Support",
  changelogJun7: "Administrator: Load app debug terminals.",
  changelogOct1: "Added features: command execution, copy configuration and mass deletion of topay messages",
  changelogNov8: "Redsys system status notification",
  changelogNov9: "Incorporation of 'New Sale' functionality in pre-authorizations",
  changelogEne4: "Device API documentation update",
  changelogMar1: "New feature for Forced Sales returns",
  changelogMar2: "Improved Vending Configuration",
  changelogAbr2: "New feature to incorporate CSS into PUCE",
  changelogMay7: "Device API documentation update",
  changelogJun8: "Improved Vending Configuration",
  changelogAug6: "Pre-authorization: new link to the cancellation/closing operation",

  // Contact.vue
  contactText: "Contact us to request your access data or report problems.",
  tecnicalSuport24: "24-hour technical support",
  phone: "Phone",
  centralita: "Switchboard",

  // UserSettings.vue
  userData: "Account data",
  saveData: "Save data",
  changeThePassword: "Password",
  currentPassword: "Current password",
  newPassword: "New Password",
  changePassword: "Change Password",
  ruleRequiredEmail: "Please enter an email.",
  ruleInvalidEmail: "The email must be valid.",
  profileUpdated: "Updated user profile",
  errorChangePassword: "There was a problem changing the password!",
  successfulChangePassword: "Password change successful",
  passwordTitle: "The password must contain:",
  passLowercase: "- At least one letter.",
  passUppercase: "- At least one capital letter.",
  passNumber: "- At least one number.",
  passEspecialChar: "- At least one special character.",
  passLenght: "- At least 8 characters.",
  usersExportFilename: "PAYTEF users listListado usuarios PAYTEF",
  export: "Export",

  // VendingConfig.vue
  vendingConfig: "Vending Configuration",
  noAvailableLogo: "Logo not available",
  edit: "Edit",
  preview: "Preview",
  terminals: "terminals",
  selectTerminalToSeeConfig: "Select a terminal to see the configuration",
  loadingData: "Loading data...",
  baseCurrency: "Base Currency",
  toPayConfig: "Configuration: ToPay",
  toPayMessageDeleted: "Topay message deleted correctly",
  site: "Site",
  machine: "Machine",
  firm: "Signature",
  operationMode: "Operation mode",
  slaveMDB: "Configuration: MDB Slave",
  chargerTitle: "Configuration: Recharger",

  firstLine: "First line",
  preauthInitialAmount: "Initial Preauthorization Amount",
  cashless: "Cashless",
  vendVendingTimeout: "Vending Timeout",
  vendVendingTimeoutHint: "Maximum time to wait after payment for the product to be dispensed (VEND SUCCESS)",
  vendSessionTimeout: "Session Timeout",
  vendSessionTimeoutHint: "Time from the start of the session until the user starts the payment process",
  vendPaymentTimeout: "Payment Timeout",
  vendPaymentTimeoutHint: "Time allowed for the user to pay after the process is started",
  machineAmount: "Machine Prices",
  priceTable: "Price table",
  priceTableWarning1: "The price table is empty, card payments will not work.",
  priceTableWarning2:
    "The price table is empty, so loading prices will clear the machine prices. Neither card nor cash payments will work until the prices are loaded.",
  priceTableAsk: "Do you want to save anyway?",
  cashSaleIncludesBaseCoin: "CashSale W/B.Coin",
  alwaysAmount: "Always Balance",
  alwaysIdle: "Always Idle",
  preauthInitial: "Initial Preauthorization",
  loadCredit: "Credit load",
  readerEnabledByDefault: "Reader enabled on startup",
  directSale: "Direct sale",
  linesGroup: " Line Group",
  validationDelay: "Validation Delay",
  pulseConfig: "Configuration: Pulse",
  pulseDuration: "Pulse Duration",
  pulseInterval: "Pulse interval",
  pulseValue: "Pulse Value",
  pulseCount: "Pulse count",
  productSelectionPolicy: "Product selection",
  line: "Line",
  pCash: "P.Cash",
  pCard: "P.Card",
  cash: "Cash",
  addLine: "Add Line",
  topayMessagesLoadMore: "Load more...",
  Preview2: "Preview",
  confirmCorrectImage: "Please confirm that the image is correct before confirming.",
  updateImage: "Update Image",
  errorLoadingLogo: "Error loading logo",
  errorLoadingTerminal: "Error loading terminal",
  successfulSave: "Saved successfully",
  errorSaving: "Error saving: ",
  errorInvalidFields: "Invalid fields, check the form",
  ruleRequiredValue: "Required value",
  ruleValueMin0: "The value must be greater than or equal to 0",
  ruleValueMAx500: "The maximum value is 500",
  errorLoadingImage: "Problem loading image",
  updatedImage: "Updated image",
  errorUloadingImage: "Problem uploading the image",
  showQR: "Show QR",
  messages: "Messages",
  topayQueuedMessages: "Topay queued messages",
  balancePresentation: "Balance Presentation",
  topayReading: "Reading",
  Language: "Language",
  toPayAutoSale: "ToPay Auto Sale",
  enabledByInputSignal: "UI enabled by input signal",
  enabledByInputSignalHint:
    "If enabled, the app will verify the signal of the selected input, if it's 1 the UI will have buttons enabled, if it's 0 the buttons will be disabled",
  noResultsVending: "NO RESULTS FOUND",
  loadingStatistics: "LOADING STATISTICS",
  configuration: "Configuration",

  topay: "ToPay",
  enabled: "Enabled",
  disabled: "Disabled",
  header: "Header",
  footer: "Footer",
  productDesc: "Product Desc.",
  changeLangTxt: "Are you sure you want to change the language?",
  changeLang: "Modify Language",
  vendingStatisticsSearch: "You can only search for up to 7 days.",
  noAditionalInformation: "THERE IS NO ADDITIONAL INFORMATION",
  executeCommand: "Execute Command",
  confirm: "Confirm",
  command: "Commands",
  actions: "Actions",
  topayMessages: "Topay Messages",
  executeCommandSuccess: "Command executed.",
  executeCommandFailed: "The command could not be executed.",
  saleRefund: "Sale / Refund",
  saleRefundHint: "Use the SALE operation instead of PREAUTHORIZATION",
  noProductsTxt: "The price list is empty, please indicate prices",
  minValueHint: "The indicated time may be insufficient.",
  importConfig: "Import Settings",
  copyTerminalConfig: "Import Terminal Settings",
  clear: "Clear",
  copy: "Copy",
  ConfigFound: "Configuration found successfully. By accepting, you can review it before saving it.",
  ConfigNotFound: "Configuration not found.",
  selectBranch: "Select Branch",
  selectTerminal: "Select Terminal",
  cardPayment: "Card Payment",
  saleMode: "Sales Mode",
  defaultAmount: "Default Amount",
  readerEnabledStart: "Disable this checkbox if machine has Age Safety Controls",
  cashSale: "Cash sale with base currency",
  cashSaleHint:
    "If activated, the value reported via MDB is multiplied by the base coin before sending the cash sale to Topay (compliant with protocol).\nIf inactive, the notification is sent to Topay with the original value received from MDB (non-compliant: the machine reports the real value of the sale).\nFor example: if the value received from the machine is 3 and the base coin is 5, if the checkbox is active, Topay will receive 15, if the checkbox is inactive it will receive 3.",
  alwaysAmountHint:
    "Assigns 1 cent of credit if the card is empty, to allow sales in devices that block sales when credit is 0",
  minCharge: "Minimum recharge",
  allowOtherCharge: "Enable recharge for another amount",
  topayTicketQr: "Enable Topay receipt",
  predefinedCharge: "Predefined recharges",
  predefinedChargeHint: "Up to 4 values ​​maximum allowed.",
  saveStatistics: "Save Statistics",
  price: "Price",
  topayOptions: "ToPay Options",
  qrCameraType: "Camera QR",
  qrFlashOn: "Turn on flash when scanning QR",
  vendingTicket: "Sale receipt",
  vendingPrintEnabled: "Enabled",
  vendingPrintDisabled: "Disabled",
  vendingVirtualTicket: "Virtual Ticket",
  vendingVirtualTicketEnable: "Show ticket on screen",
  vendingPrintWithoutPrompt: "Print without confirmation prompt",
  vendingPaperTicket: "Paper Ticket",
  vendingPaperTicketEnable: "Print paper ticket",
  vendingPaperWidth: "Paper Width",
  vendingPrinterType: "Printer Type",

  //AuthRegister.vue
  alreadyGotAccount: "Do you already have an account?",

  //Error.vue
  error: "Error",
  noAccessToPage: "You do not have permission to access this page.",
  unexpectedError: "An unexpected error occurred",

  //PaymentEdit.vue
  newPaymentRequest: "New payment request",
  editPaymentRequest: "Edit payment request",
  copyResquest: "Copy request",
  cancelRequest: "Cancel request",
  finishAndbackToList: "Finish and return to the list",
  unabledOffice1: "The branch of this request is disabled or does not exist. Sign in to",
  unabledOffice2: "branch setup",
  unabledOffice3: "to enable it.",
  publish: "Publish",
  finishRequestLegend:
    "At the end of the request you will no longer be able to edit it and it will be visible to final users who have the payment link.",
  publishedRequest: "Published request!",
  canSendTeRequestTo:
    "You can now send the request to the customer. Press below for us to send an e-mail or send the payment link on your own.",
  sendPaymentEmail: "Send payment email",
  previewEmail: "Preview Email",
  paymentLinkText: "You can send this link to the person you want to make the payment.",
  paymentLinkUrlHint: "Press CTRL+C (on PC) or CMD+C (on MAC) to copy the content",
  customForm: "Custom form",
  preview2: "Preview",
  openAnotherWindow: "Open another tab",
  alertPublisRequet: "¡Published request!",
  alertCancelRequet: "Cancelled request.",
  alertSuccessEmail: "Mail sent successfully.",
  errorCouldNotGeneratePreview: "Failed to generate preview",
  erroCouldNotUpdateRequet: "Failed to update request",
  alertFinish: "¡Request completed!",
  alertExpired: "¡Request expired!",
  alertCanceled: "¡Request canceled!",
  alertAproved: "¡Application approved!",
  linkCopied: "¡Copied link!",
  pressControlC: "Press CTRL+C (on PC) or CMD+C (on MAC) to copy.",
  wantToPublish: "¿Are you sure you want to publish the request? \n Once published, it cannot be edited again.",
  wantToCancel: "¿Are you sure you want to cancel the request?",
  couldNotLoadRequest: "The payment request could not be loaded",

  //PaymentLinkAPI.vue
  paymentLinkApiTitle: "PaymentLINK API",
  enableApi: "Enable api",
  eneableApiText: "To access the API you have to enable it and generate an access token.",
  accessToken: "Access token",
  accessTokenHint: "Press CTRL+C (on PC) or CMD+C (on MAC) to copy the content",
  generateNewToken: "Generate new token",
  generateNewTokenText1: "The access token is added in the HTTP header",
  generateNewTokenText2: "authorization",
  generateNewTokenText3: "with the following format. The content must start with",
  generateNewTokenText4: "PAYTEF-TOKEN",
  generateNewTokenText5: "and then the token.",
  generateNewTokenExample1: "An example can be seen below:",
  generateNewTokenExample2:
    "It is important not to expose the token to final users. It should be used only in server-to-server communications.",
  errorLoadingConfig: "Error loading configuration",
  errorSavingConfig: "Error saving configuration",
  generateNewTokenConfirmation: "Generating a new token will disable the old token. Do you want to continue?",

  //PaymentList.vue
  goToReq: "Go to request",
  test2: "test",
  ID: "ID",
  sendConfirEmail: "Send request email",
  selectMerchantToSeeRequest: "Select a company to view requests.",
  applyFilters: "Apply the filters to see the requests.",
  requestsNotFound1: "No payment requests found for",
  requestsNotFound2: "between",
  requestsNotFound3: "and",
  requestsNotFound4: "Try other filters.",
  selectFiltersToSeeReq: "Select the filters to see the requests.",
  loadMore: "Load more...",
  close: "Close",
  from: "From",
  to: "To",
  requestStatus: "Request Status",
  goToRequest: "Go to request",
  navigateToRequest:
    'You can navigate directly to the desired application by indicating the ID below and pressing the "Browse" button:', //VER browser
  requestIdEx: "Request ID (Example: gmdHJX7lyPe9SE...)",
  navigateToRequestBtn: "Browse on demand",
  sendConfirmationEmail: "Send confirmation email",
  creation: "Creation",
  expiration: "Expiration",
  visible: "Visible",
  errorSelectParamsToQuery: "Select the parameters before making the query.",
  errorFilteringResultsRetry: "An error occurred filtering the results, please try again.",
  all: "All",
  pending: "Pending",
  cancelled: "Cancelled",
  expired: "Expired",
  filenameName1: "Payment requests",
  filenameName2: "from",
  filenameName3: "to",
  paymentRequet: "Payment requests",
  errorSendingEmail: "error sending email",
  onExpireCharge: "Operation Processed at Due Date = ",

  // TerminalQRConfig.vue
  terminalConfig: "Terminal Configuration",
  terminalConfigText: "This page contains the data necessary to configure your terminal.",
  generatingQR: "Generating QR code",
  errorGeneratingQR: "Error creating QR, try reloading the page or contact PAYTEF",
  errorExtractingDataQR:
    "The QR data could not be extracted, it may not correspond to a valid QR. If your device does not process the image, contact PAYTEF.",

  // Test.vue
  importData: "Import Data",
  importUsers: "Import users",
  importMerchants: "Import company",
  importData2: "Import Data",
  uploadFile: "Upload file",
  pressImportToStart: "Press import to start.",
  usersLoading: "Users...",
  merchantsLoading: "Companies...",
  merchantsInvoking: "Company: Invoking service...",
  merchantsWaiting1: "Companies: Imported. Waiting ",
  merchantsWaiting2: " secs for the next company.",
  finished: "Finished.",

  // DATATABLES
  rowsPerPage: "Rows per page:",
  noResultsAvailable: "No data available",
  datatableLoading: "Loading...",

  // PaymentForm.vue
  paymentData: "Payment Details",
  selectCompany: "Select Company",
  branch: "Branch",
  referenceNumber: "Reference number (Reservation, invoice, etc.)",
  currency: "Currency",
  createPaymentToken: "Create card token (Tokenization)",
  testRequest: "Is it a test request?",
  payerMessage: "Message to the customer",
  timeLimitToPay: "Time limit for payment",
  timeZone: "Time zone",
  dateLimit: "Deadline",
  validHours: "Hours of validity",
  paymentDateLimit: "Payday limit",
  paymentDateLimitText:
    "The validity time of the request includes the selected date. The payment will expire at 23:59 on the selected day in the selected timezone.",
  hoursQuantity: "Number of hours",
  hoursQuantityText: "The hours are counted from the moment of creation of the payment request",
  radioCustomerAuthentication: "Customer authentication",
  radioCustomerAuthenticationWeak: "Weak (Not secure)",
  radioCustomerAuthenticationStrong: "Strong (Secure)",
  payCFString: "String",
  payCFNumber: "Number",
  payCFCountry2: "Country (ISO 2)",
  payCFCountry3: "Country (ISO 3)",
  payCFSelect: "List",
  payCFRadioVertical: "Radio (vertical)",
  payCFRadioHorizontal: "Radio (horizontal)",
  payCFCheckbox: "Checkbox",
  payCFDate: "Date",
  payCFPhone: "Phone",
  payerData: "Customer data",
  fullName: "Full name",
  emailAddress: "Mail address",
  cardNumberOptional: "Card number (Optional)",
  mmyy: "MM/YY",
  edtiCard: "Edit Card",
  lang: "Language",
  description: "Descripcion",
  defaultValue: "Default value",
  type: "Type",
  required: "Required",
  maxLength: "Max. length",
  ej250: "eg. 250",
  addField: "Add Field",
  details: "Details",
  delete: "Delete",
  addDetails: "Add Detail",
  sumOtherThan: "Sum other than ",
  attachedFiles: "Attached files",
  aditionalInfoText1: "Additional information such as invoices, vouchers and other documents. The images indicated as ",
  aditionalInfoText2: "inline",
  aditionalInfoText3: " are displayed together with the application data without the need to download them.",
  noAttachedFiles: "No attachments",
  inline: "Inline",
  addFile: "Add file",
  goToList: "Go to the list",
  errorVerifyFields: "Check the fields with errors",
  errorSumIncorrect: "The sum of the details is incorrect",
  savedRequest: "¡Saved Request!",
  errorCouldNotSave: "Failed to save request",
  ruleSelectCompany: "Select a company",
  ruleRequiredField: "This field is required",
  ruleDateHigher: "Date must be greater than today",
  ruleMinValue1: "Minimum value is 1",
  ruleMinValue0: "The value must be greater than 0",
  ruleInsertVaule: "Please enter a value",
  ruleInvalidValue: "The number is invalid or not supported.",
  ruleInvalidValue2: "Invalid value",
  advancedOptions: "Advanced Options",
  urlNotifyLabel: "Payment notification url (Optional)",
  urlNotifyKoLabel: "Expiration notification url (Optional)",
  urlNotifyTooltip1: "URL that will receive a POST request when the user pays. ",
  urlNotifyTooltip2: "The paymentID attribute of the JSON body will indicate the request. ",
  urlNotifyTooltip3: "For more information contact the ",
  urlNotifyTooltip4: "Technical service.",
  urlNotifyTooltip5: "URL that will receive a POST request when the payment link expires. ",

  // BetterHeaderFilter.vue
  selectAll: "Select all",

  // ColorPicker.vue
  primaryColor: "Primary Color",
  ruleHtmlFormat: "The format must be HTML hexadecimal (eg #FFFFFF).",

  // CompanyEdit.vue
  andoidLogo: "Logos in PAYTEF Android",
  mainViewLogo: "Main screen logo",
  secondaryViewLogo: "PAYTEF Android secondary logo",
  imgPngDescription: "PNG image with transparent background. Maximum size 530x210, less than 5MB.",
  remove: "Delete",
  logoInReceipt: "Logo on the receipt",
  lagoReceipts: "receipts logo...",
  receiptLogoText: "Only black and white in PNG format, maximum width 400 pixels.",
  errorLoadingData: "Error loading data.",
  errorUploadingFile: "Error uploading file, please try again.",

  // EmailPreviewDialog.vue
  emailContent: "Email content",

  // LinkRef.vue
  emptyFile: "Empty file.",
  errorAccessingFile: "Error accessing file, not found.",

  // TxnEditDialog.vue
  cancelPreauthorization: "Cancel pre-authorization",
  closePreauthorization: "Close pre-authorization",
  newCollectOnCard: "New charge on card",
  newCardCollect: "New charge on card",
  newCardCollectText1:
    "This action will void the pre-authorization and release the reserved funds back to the original card. Check the data below.",
  newCardCollectText2:
    "This action will confirm the transaction and make the actual charge of the pre-authorized funds. Check the data below.",
  newCardCollectText3: "The amount will be returned to the card for this transaction. Check the data below.",
  newCardCollectText4: "A new amount will be charged to the original transaction card. Check the data below.",
  originialTransaction: "Original transaction",
  originaAmount: "Original amount",
  newTransactionDataTilte: "Data of the new transaction",
  transactionReferenceId: "Reference / transaction identifier",
  refundAmount: "Amount to refund",
  collectAmount: "Amount to collect",
  warning: "Warning",
  warningAmountLargerThan: "The amount exceeds the original transaction amount.",
  adicinalComments: "Additional comments (reason for the transaction, additional data, etc.)",
  toConfirmOperation1: "To confirm the operation type",
  toConfirmOperation2: "below and press",
  accept: "Accept",
  back: "Back",
  ruleMAx500: "Maximum length: 500",
  errorCheckForm: "Please check the form, data is missing.",
  alertEditedTransaction: "¡Successfully Modified Transaction!",
  errorCouldNotEditTransaction: "The transaction could not be modified",
  write: "Write",
  refunds: "Refunds",
  history: "History",

  // TxnInfoDialog.vue
  originalId: "Transaction",
  user: "User",
  comment: "Comment",
  newCollect: "New charge",
  closePreauth: "Close Pre-auth.",
  cancelPreauth: "Cancel Pre-auth.",
  previousOperation: "Previous Operation",
  goToOperation: "Return to Operación",
  forceSale: "Sale (Forced)",
  forceRefund: "Refund (Forced)",
  forceSaleTitle: "Sale. Force Operation",
  forceRefundTitle: "Refund. Force Operation",
  forceText: "Are you sure you want to run the operation?",
  forceWarning: "This action cannot be undone.",
  closeCancelation: "Closure/ Cancellation",

  // TxnReceiptDialog.vue
  loadingReceipt: "Loading the receipt...",
  couldNotLoadFirm: "Unable to load signature",
  transactionNoReceipt: "This transaction has no receipt or an error occurred.",
  loadAgain: "Load again",
  receipt: "Receipt",

  // Upload.vue
  maxSize: "Maximum size",
  fileUploaded: "File uploaded.",
  fileToBig: "The file is too large. Maximum size",
  cancelled2: "Cancelled.",
  couldNotUploadFile: "The file could not be uploaded.",
  invalidUser: "Invalid User.",
  search2: "Search",

  //UserEditDialog.vue
  editUser: "Edit User",
  newUser: "New User",
  sendResetPass: "Send password reset",
  assignPass: "Assign Password",
  newPass: "New Password",
  disabledAccountTxt1:
    "This account is disabled, the user will not be able to access the system or see their companies.",
  disabledAccountTxt2: "Contact PAYTEF to enable it.",
  accountRolPerCompany: "Per Company Account Permissions",
  adminInterfaceLbl: "Management interfaces",
  consultStadisticsLbl: "Query statistics",
  consultConnTermLbl: "Consult connections and terminals",
  seeClientApi: "View client API",
  consultTransactions: "Query transactions",
  editTransactions: "Edit transactions",
  allowedBranches: "Branches allowed",
  addCompanyToAddRole: "Add a company to assign permissions to this user.",
  assignRoleBeforeSave: "Please assign rol to the user before saving.",
  blockAccess: "Block Access (disable account)",
  specialPermissions: "Special permissions",
  enableEditing: "Enable editing",
  specialPermissionsWarning:
    "These permissions are potentially dangerous, only assign them to users that really need them, do not assign these permissions massively",
  alertUserSavedRefresh: "User Saved Successfully! Refreshing list.",
  alertUserSavedSendedPasswordEmail: "User Saved Successfully! Password email sent.",
  errorCouldNotSaveUser: "Failed to save user",
  noAvailableCompanies: "There are no shops available",
  alertInvalidAddress: "Invalid email address.",
  resetEmailSended: "Password reset email sent",
  noPermissions: "No permissions",

  // UserAuditDialog.vue
  accessLogs: "Access logs",
  logsLimit: "Logs Limit",
  userWithoutAccessLog: "This user has no registered access.",
  logSearchFrom1: "The search of",
  logSearchFrom2: "got no results.",
  errorUserList: "Could not get user list",
  accessUtc: "Access (UTC)",
  uid: "UID",

  //euroshellCertificate.vue
  newCertificate: "New Certificate",
  newEuroshellCertificate: "New Euroshell Certificate",
  download: "Download",
  noCertificatesAvailable: "There are no certificates generated on the selected dates",
  euroshellCertificates: "Euroshell Certificates",
  dateOfIssue: "Date of Issue:",
  previousTransaction: "Previous transaction",

  // management.vue
  debugTerminals: "DEBUG Terminals (DISA)",
  noTerminalsAvailable: "No DEBUG terminals found.",
  newTerminal: "New Terminal",
  editTerminal: "Edit Terminal",
  mac: "MAC",
  app: "App",
  administration: "Administration",
  deleteDebugTerminalText: "Are you sure you want to delete the terminal, this action cannot be undone.",
  deleteTerminal: "Delete Terminal",
  delete1: "Delete",

  // Payment loading leave-confirmation
  confirmLeaveTitle: "Are you sure you want to leave?",
  confirmLeaveText: "The payment request is being saved. Leaving now could interrupt the operation.",
  confirmLeaveBtnStay: "Stay",
  confirmLeaveBtnLeave: "Leave anyway"
};

export default lang;
